export default "__VITE_ASSET__aqBxqgir__"